export default __webpack_public_path__ + "static/help_02_08_2-0e8ae19cde73d1a68bf47c91c798a356.png";